import { useState } from "react"
import MostBookServi from './MostBookServi'

export default function ContMost() {
const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevState) => ({ ...prevState, [name]: value }))
  }

 
  const buttonhnd=async(e1)=>{
    e1.preventDefault();
  
    fetch("https://portfolioback-nu.vercel.app/accontact", {
  
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        
          alert("we will contact  you soon!n Have a good day");
       
        })
  
    
  console.log(formData);
  }

  return (
    <div className="container py-5" >
      <MostBookServi></MostBookServi>
      <h1 className="text-center mb-5">Contact Us</h1>
      <div className="row">
        <div className="col-md-6 mb-4 mb-md-0">
          <h2>Get in Touch</h2>
          <p>
            We're here to help with all your appliance repair needs. Don't hesitate to reach out to us for any questions
            or to schedule a repair.
          </p>
          <ul className="list-unstyled">
            <li>
              <strong>Address:</strong>841226 Mohiuddinpur
              Siwan Bihar
            </li>
            <li>
              <strong>Phone:</strong>9199245536
            </li>
            <li>
              <strong>Email:</strong> onestopservice@gmail.com
            </li>
            <li>
              <strong>Hours:</strong> Monday - Thursday: 8am - 6pm, Friday:9am-12pm,3pm-6pm ,Saturday: 9am - 3pm
            </li>
          </ul>
        </div>
        <div className="col-md-6 container" id="frm" >
          <form onSubmit={buttonhnd}>
            <div className="mb-3 mt-3 mb-3 ms-3 me-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your Name"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 mt-3 mb-3 ms-3 me-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 mt-3 mb-3 ms-3 me-3">
              <label htmlFor="phone" className="form-label">
                Phone
              </label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                name="phone"
                value={formData.phone}
                placeholder="Enter your Phone Number"
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 mt-3 mb-3 ms-3 me-3">
              <label htmlFor="service" className="form-label">
                Service Needed
              </label>
              <select
                className="form-select"
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select a service</option>
                <option value="AC Repair">AC Repair</option>
                <option value="Refrigerator Repair">Refrigerator Repair</option>
                <option value="Washing Machine Repair">Washing Machine Repair</option>

              <option value="Interior Painting">Interior Painting</option>
<option value="Exterior Painting">Exterior Painting</option>
<option value="Residential Painting">Residential Painting</option>
<option value="Commercial Painting">Commercial Painting</option>
<option value="Specialty Finishes">Specialty Finishes</option>
<option value="Surface Preparation">Surface Preparation</option>
<option value="Staining & Varnishing">Staining & Varnishing</option>
<option value="Leak Detection & Repair">Leak Detection & Repair</option>
<option value="Drain Cleaning & Unclogging">Drain Cleaning & Unclogging</option>
<option value="Water Heater Services">Water Heater Services</option>
<option value="Fixture Installation">Fixture Installation</option>
<option value="Pipe Repair & Replacement">Pipe Repair & Replacement</option>
<option value="Emergency Plumbing">Emergency Plumbing</option>
<option value="Residential Cleaning">Residential Cleaning</option>
<option value="Commercial Cleaning">Commercial Cleaning</option>
<option value="Deep Cleaning">Deep Cleaning</option>
<option value="Move-In / Move-Out Cleaning">Move-In / Move-Out Cleaning</option>
<option value="Carpet & Upholstery Cleaning">Carpet & Upholstery Cleaning</option>
<option value="Window Cleaning">Window Cleaning</option>

                <option value="Other">Other</option>
              </select>
            </div>
            <div className="mb-3 mt-3 mb-3 ms-3 me-3">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                className="form-control"
                id="message"
                name="message"
                placeholder="Your Message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary mt-3 mb-3 ms-3 me-3">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
